import { init as initSelects } from '../../commons/select';
import { init as initSpotLightSlicks } from './spotlights-slicks';

function bind() {
  const sortOption = cube.$id('dkt-select-sort-option');

  if (sortOption)
    sortOption.addEventListener('change', sortProducts);
}

function unbind() {
  const sortOption = cube.$id('dkt-select-sort-option');
  if (sortOption)
    sortOption.removeEventListener('change', sortProducts);
}

function sortProducts() {
  unbind();

  $(this).FiltersCommonFunctionalitiesPlugin(
    'reloadListingCartridges',
    this.value,
    this.dataset.url
  );
}

function slickAddExtraClasses(target) {
  const currentSlide = $(target).find('.slick-product').slick('slickCurrentSlide');
  $(target).find('.slick-thumbs').find('.slick-current').removeClass('slick-current');
  $(target).find(`.slick-thumbs [data-slick-index=${currentSlide}]`).addClass('slick-current');
}

export function init() {
  // Initialize select component //
  initSelects();

  initSpotLightSlicks();

  cube.event.on('doTheReload', unbind);
  cube.event.on('listPageElementsRefresh', () => {
    setTimeout(bind, 0);
  });

  bind();

  $('body').on('swipe', '.pl-element', e => slickAddExtraClasses(e.target));
}



// WEBPACK FOOTER //
// ./src/catalog/product-list/product-list.js